import graphqlClient from '../../api/axios_interceptor';
import {
    getTenantTransactions
} from "../../api/graphql/queries/transactions";
import { updateActionErrors } from './updateErrors';
import {
    FETCH_TRANSACTIONS
} from '../actions/actionTypes';
import {convertDateToUserLocalDate} from "../../utils/general"


export const parseTransaction = (transaction) => ({
    ...transaction,
    date: transaction.date ? convertDateToUserLocalDate(transaction.date) : "",
    shortDescription: (
        transaction.description.length > 10 ?
            transaction.description.substring(0, 10) + " ..." :
            transaction.description
    )
})
export const fetchTransactionsMiddleware = async (action) => {
    try {
        let transactions = {};
        const payload = action.payload;
        await graphqlClient({
            data: {
                query: getTenantTransactions(payload.tenantId, payload.startDate, payload.endDate)
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else {
                transactions = queryResult.data.data.tenantTransactions.map(parseTransaction);
                action = {
                    ...action,
                    payload: {
                        ...action.payload,
                        transactions,
                        accountBalance: (transactions.length > 0 ? transactions[0].endOfDayBalance : null)
                    }
                };
            }
        })
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }

    return action;
}

export const transactionsMiddleware = storeAPI => next => async action => {
    switch (action.type) {
        case FETCH_TRANSACTIONS:
            action = await fetchTransactionsMiddleware(action);
            break;
    }
    return next(action);
}